import { useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { Trash2, Signature } from 'lucide-react'

const SignaturePad = ({ onSignature }) => {
  const sigCanvasRef = useRef<SignatureCanvas | null>(null)
  const [isEmpty, setIsEmpty] = useState(true)

  const clearSignature = () => {
    if (sigCanvasRef.current) {
      sigCanvasRef.current.clear()
      setIsEmpty(true)
      onSignature(null)
    }
  }

  const canvasToFile = (filename = 'signature.png'): File | null => {
    if (!sigCanvasRef.current || sigCanvasRef.current.isEmpty()) return null
    const dataUrl = sigCanvasRef.current.getCanvas().toDataURL('image/png')
    const arr = dataUrl.split(',')
    const mimeMatch = arr[0].match(/:(.*?);/)
    const mime = mimeMatch ? mimeMatch[1] : 'image/png'
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }

  const handleEndDrawing = () => {
    if (sigCanvasRef.current) {
      const empty = sigCanvasRef.current.isEmpty()
      setIsEmpty(empty)

      if (!empty) {
        const file = canvasToFile()
        console.log('Signature File:', file)
        onSignature(file)
      }
    }
  }

  return (
    <div className="relative w-full border border-secondary-200 bg-secondary-50/30 rounded-2xl overflow-hidden shadow-xs">
      <div className="flex items-center justify-between px-4 py-3 bg-secondary-50/80 border-b border-secondary-200/80">
        <div className="flex items-center gap-2 select-none">
          <span className="p-1 rounded-md bg-secondary-200/60 text-secondary-600 flex items-center justify-center">
            <Signature size={12} />
          </span>
          <span className="text-[10px] font-bold uppercase tracking-wider text-secondary-500">Authorized Signature</span>
        </div>
        <button
          type="button"
          onClick={clearSignature}
          disabled={isEmpty}
          className="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-bold text-rose-600 hover:bg-rose-50 disabled:text-secondary-400 disabled:bg-transparent rounded-lg transition-all duration-150"
        >
          <Trash2 size={13} />
          Clear
        </button>
      </div>

      <div className="relative bg-white">
        <SignatureCanvas
          ref={(canvasRef) => { sigCanvasRef.current = canvasRef }}
          penColor="#0f172a" // slate-900 for dark ink
          canvasProps={{ className: 'w-full h-44 cursor-crosshair block relative z-10' }}
          onEnd={handleEndDrawing}
        />
      </div>
    </div>
  )
}

export default SignaturePad
